import React, { useState } from "react";
import { useRef } from "react";
import { Button } from "react-bootstrap";
import DateModal from './DateModal'

const styles={
    wrapper:{ margin: "0 auto", width: "100%" },
    select:{width:'100%',padding:'1rem',borderRadius:'4px',backgroundColor:'#fff',fontSize:'14px'},
    options: {
        width: "100%",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "flex-end",
        marginTop: "2rem",
        flexWrap:'wrap',
        gap:'1.4rem'
    },
}


const OptionsBar = ({handleChange,filterConsts,handleSearch,generateCSV}) => {

    const select = useRef()
    const [lastFilterSelected,setLastFilter] = useState('') //para manejo del select en caso de cerrar el modal sin escoger fecha

    const [showDateModal,setDateModal] = useState(false)
    const [selectedDates,setSelectedDates] = useState(null)


    function handleSelect(e){
        const value = e.target.value
        setSelectedDates(null)

        if(value === filterConsts.SELECT){
            return setDateModal(true)
        }else{
            setLastFilter(value)
            return handleChange(value)
        }
    }

    function handleCustomDate(dateFrom,dateTo){
        setDateModal(false)
        setSelectedDates({dateFrom,dateTo})
        handleChange(filterConsts.SELECT, {dateFrom,dateTo})
        select.current.value = 'default'
    }

    function handleClose(){
        setDateModal(false)
        select.current.value = lastFilterSelected || 'default'
    }


    return (
        <div style={styles.options}>
            <div style={{ width: "20%", position:'relative',minWidth:"180px" }}>
                <label>Filtrar por Fecha:</label>
                <select
                    ref={select}
                    style={styles.select}
                    onChange={handleSelect}
                    defaultValue={'default'}
                >
                    <option disabled value="default">--Elige una Opción--</option>
                    <option value={filterConsts.ALL}>Todos</option>
                    <option value={filterConsts.TODAY}>Hoy</option>
                    <option value={filterConsts.WEEK}>Esta Semana</option>
                    <option value={filterConsts.MONTH}>Este Mes</option>
                    <option value={filterConsts.SELECT}>Seleccionar</option>
                </select>
                {selectedDates && (
                    <small style={{position:'absolute', top:'calc(100% + 5px)', left:'0'}}><b>Fecha: </b><i>{selectedDates.dateFrom} / {selectedDates.dateTo}</i></small>
                )}
            </div>

            <div style={{ width: "25%",minWidth:"240px"}}>
                <label>Buscar:</label>
                <input
                    style={styles.select}
                    type="text"
                    onKeyUp={handleSearch}
                    placeholder="Buscar por: email, nombre, apellido..."
                />
            </div>

            <div style={{ width: "150px" }}>
                <Button
                    style={{ width: "100%", padding: "1rem" }}
                    bsStyle="primary"
                    onClick={generateCSV}
                >
                    Exportar
                </Button>
            </div>

            {showDateModal && <DateModal show={showDateModal} onClose={handleClose} onConfirm={handleCustomDate}/>}
        </div>
    );
};

export default OptionsBar;



// WEBPACK FOOTER //
// ./src/scenes/reportes/components/OptionsBar.js